import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Info';
import React from 'react';

import styles from './Warning.module.scss';

const Warning = props => {
  let icon = null;
  let className = null;
  switch (props.type) {
    case 'none':
      icon = null;
      className = styles.none;
      break;
    case 'warning':
      icon = <CloseIcon className={styles.icon} />;
      className = styles.warning;
      break;
    case 'error':
      icon = <CancelIcon className={styles.icon} />;
      className = styles.error;
      break;
    case 'success':
      icon = <CheckIcon className={styles.icon} />;
      className = styles.success;
      break;
  }

  return (
    <div className={`${className} ${props.className || ''}`}>
      {icon ? <div className={styles.warningIcon}>{icon}</div> : null}
      <div className={styles.warningCopy}>
        {props.title ? (
          <div>
            <em>{props.title}</em>
          </div>
        ) : null}
        {props.description ? (
          props.title ? (
            <p>{props.description}</p>
          ) : (
            <div>{props.description}</div>
          )
        ) : null}
        {props.details ? <p className={styles.details}>{props.details}</p> : null}
      </div>
    </div>
  );
};

export default Warning;
